export function set(state, { id, item }) {
  state.byId[id] = { item, ts: Date.now() };
}

export function setInflight(state, { id, p }) {
  state.inflight[id] = p;
}

export function clearInflight(state, id) {
  delete state.inflight[id];
}
